import { Box, IconButton, Stack, Typography } from "@mui/material";
import { usePanelContext } from "../../../context/panelContext";

export default function HeaderComponent() {
  const { setDrawerOpen, drawerOpen } = usePanelContext();

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <Stack
        width="100%"
        px={{ xs: "26px", md: "44px" }}
        py={{ xs: "14px", md: "20px" }}
        justifyContent="space-between"
        alignItems="center"
        direction="row"
        bgcolor={(theme) => theme.palette.gray[50]}
        sx={{
          borderBottomColor: (theme) => theme.palette.gray[400],
          borderWidth: "1px",
          borderStyle: "solid",
          zIndex: "1000",
          py: { xs: "40px", md: "45px" },
        }}
      ></Stack>
      <Stack
        width="100%"
        px={{ xs: "26px", md: "44px" }}
        py={{ xs: "14px", md: "20px" }}
        justifyContent="space-between"
        alignItems="center"
        bgcolor={(theme) => theme.palette.gray[50]}
        direction="row"
        sx={{
          borderBottomColor: (theme) => theme.palette.gray[400],
          borderWidth: "1px",
          borderStyle: "solid",
          zIndex: "1000",
          position: "fixed ",
          top: "0",
        }}
      >
        <IconButton
          sx={{ display: { xs: "block", md: "none" } }}
          onClick={handleDrawerToggle}
        >
          <img src="/images/menu.svg" />
        </IconButton>

        <Stack
          sx={{
            my: "8px",
            justifyContent: "start",
            alignItems: "start",
          }}
        >
          <img src="/images/navanak.svg" style={{ scale: ".9" }} />
        </Stack>
      </Stack>
    </>
  );
}
